import React from 'react';

import type { ExtensionComponentProps } from '@atlaskit/editor-common/extensions/extension-manifest';
import type { EditorContentMode } from '@atlaskit/editor-common/types/editor-appearance';

import { Attribution } from '@confluence/error-boundary/entry-points/Attribution.ts';
import { ErrorBoundary } from '@confluence/error-boundary/entry-points/ErrorBoundary.ts';

import type { LegacyContentMacroParams } from './LegacyContentMacroParams.ts';
import { NBMRendererServer } from './NBMRenderer.tsx';

export type LegacyContentExtensionHandlerProps =
	ExtensionComponentProps<LegacyContentMacroParams> & {
		contentId?: string;
		contentMode?: EditorContentMode;
	};

export const LegacyContentExtensionHandler = (
	props: LegacyContentExtensionHandlerProps,
): React.JSX.Element => {
	return (
		<ErrorBoundary
			attribution={Attribution.BACKBONE}
			attributes={{ contentId: props.contentId, nodeLocalId: props.node?.localId }}
		>
			<NBMRendererServer
				contentId={props.contentId}
				contentMode={props.contentMode}
				node={props.node}
			/>
		</ErrorBoundary>
	);
};
